var APP = {};
APP.initialize = function() {
  this.initRegex();
  this.initToTop();
};

APP.initRegex = function() {
    $('body').on('keypress', '[data-regex="phone-number"]', function (e) {
        if (e.which != 8 && e.which != 0 && e.which != 45 && (e.which < 48 || e.which > 57)) {
            e.preventDefault();
        }
    }).on('blur', '[data-regex="phone-number"]', function (e) {
        if ($(this).val() == '') return;
        var trans_num = $(this).val().replace(/\s/gi, "").replace(/-/gi, '');
        if (trans_num != null && trans_num != '') {
            if (trans_num.length == 11 || trans_num.length == 10) {
                var regExp_ctn = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
                if (regExp_ctn.test(trans_num)) {
                    trans_num = trans_num.replace(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/, "$1-$2-$3");
                    $(this).val(trans_num);
                    return true;
                }
            }
            toastr.error('유효하지 않은 전화번호 입니다.');
            $(this).val("");
            $(this).focus();
        }
    });
};

APP.initToTop = function() {
    $('[data-toggle="to-top"]').click(function(){
        $('html,body').animate({
            scrollTop:0
        },300);
    });

    $(window).scroll(function(){
        var scrollTop = $(window).scrollTop();
        if(scrollTop > $(window).height() / 2 ) {
            $('[data-toggle="to-top"]').fadeIn('fast');
        }
        else{
            $('[data-toggle="to-top"]').fadeOut('fast');
        }
    }).scroll();
};


$(function() {
   APP.initialize();
});